// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { UserService } from '@daml.js/utility-collateral-app-v1/lib/Utility/Collateral/App/Service/User';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useQueryWithOptions } from '../../../other/useQueryWithOptions';
import { useOperatorParty } from '../../utility-operator/useOperatorParty';

const useUserServices: () => UseQueryResult<TemplateContract<UserService>[], string> = () => {
  const ledgerApi = useLedgerApiClient();
  const operator = useOperatorParty()?.data;

  return useQueryWithOptions({
    queryKey: ['queryCollateralUserServices', operator],
    enabled: !!operator,
    select: (data: TemplateContract<UserService>[]) =>
      data.filter((d) => d.payload.operator === operator),
    queryFn: async (_, options) => {
      if (!options || !operator) {
        return Promise.resolve([]);
      }
      return ledgerApi.query(options, UserService);
    },
  });
};

export default useUserServices;
